module.exports = __webpack_public_path__ + "assets/img/logo.69d3d71c.svg";